export type TextExerciseModel = typeof textExerciseStateModel;

const textExerciseStateModel = {
  currentText: {},
  getNextText: false,
  lastVisitedQuestion: { index: null, choices: [] },
  textIsShowing: true,
  registerInProgressBarFromText: false,
};

export default textExerciseStateModel;
